"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ErrorBannerProps {
  children: ReactNode;
  className?: string;
}

/** Shared red alert box used across the wizard. No `dark:` variants — this app has no dark theme, only OS `prefers-color-scheme`, which made it unreadable. */
export function ErrorBanner({ children, className }: ErrorBannerProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700",
        className,
      )}
    >
      {children}
    </div>
  );
}
